import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import YourEventsList from "../components/YourEventsList";
import useTitle from "../components/Title";

const YourEvents  = () => {
  useTitle("Manage Events");

  return (
  <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">

          <h1 className="mt-5 event-heading-start">Manage Events.</h1>
          <p className="event-sub-text mb-3"> Here is a list of all your Events.  </p>
          <div className="row justify-content-between filter-section mx-0 align-items-end">
          </div>

          <YourEventsList />
        </div>
      </div>
      <Footer />
  </div>
  );
};

export default YourEvents;